import { t } from '@sportninja/common/i18n'

const translate = t as (
  key: string,
  options?: Record<string, unknown>
) => string

/** Every visible string in the calendar goes through here — no baked English. */
export const calendarLabel = (
  key: string,
  params?: Record<string, unknown>
): string => translate(`common:${key}`, params)

export const DAY_HEADER_KEYS = [
  'calendarDaySun',
  'calendarDayMon',
  'calendarDayTue',
  'calendarDayWed',
  'calendarDayThu',
  'calendarDayFri',
  'calendarDaySat',
] as const
